const acts = [
  {
    playName: "The Rocky Horror Show",
    playDate: "October thirty-first, 2025",
    description:
      "Get ready for a night of outrageous fun with The Rocky Horror Show! This cult classic musical takes innocent Brad and Janet on a journey as they stumble upon the mysterious castle of Dr. Frank-n-Furter, a mad scientist with a flair for the flamboyant. Featuring iconic songs like 'Time Warp' and 'Sweet Transvestite,' The Rocky Horror Show is an electrifying celebration of freedom, identity, and campy horror. This interactive performance invites audiences to participate by calling out iconic lines and engaging with the cast. For safety, ACT will provide interactive show kits for purchase to join in on the fun (outside kits are not permitted). Put on your fishnets, get ready to dance, and immerse yourself in this unforgettable late-night experience!",
    preShowDescLink:
      "https://docs.google.com/document/d/1QZLYnapV9E3UuZ7cMqtaQLJ9Ul5IPLto/edit?usp=sharing_eil_se_dm&rtpof=true&sd=true&ts=69036d1c",
    runTime: "2 hours and 15 minutes with a 15 minute intermission",
    accessibility:
      "Accessible wheelchair/scooter seating and Listening Devices are available for all performances.",
    contentAwareness:
      "Contains sexual themes, adult humor, and mild horror elements.",
  },
  {
    playName: "Rudolph The Red-Nosed Reindeer: The Musical",
    playDate: "December twelvth and fourteenth, 2025",
    description:
      "The beloved TV classic soars off the screen and onto the stage! Join Rudolph, Hermey the Elf, Yukon Cornelius, and all your favorite characters as they come to life in this heartwarming holiday musical. Featuring iconic songs like “Holly Jolly Christmas” and “The Most Wonderful Day of the Year,” this show celebrates the 61st anniversary of the cherished Christmas special. Perfect for the whole family!",
    preShowDescLink:
      "https://docs.google.com/document/d/1AzAjglFoDrCBEHxgXQQmFcSPivaM_WpI/edit",
    runTime: "90 minutes with one 15-minute intermission.",
    accessibility:
      "Accessible wheelchair/scooter seating and Listening Devices are available for all Mainstage performances.",
    contentAwareness: "This show is suitable for all audiences.",
  },
  {
    playName: "RENT",
    playDate: "February thirteenth and fifteenth, 2026",
    description:
      "La Vie Bohème! Jonathan Larson’s Pulitzer Prize–winning musical follows a year in the life of young artists and friends struggling to create and survive in New York City under the shadow of the HIV/AIDS epidemic. With an iconic rock score including “Seasons of Love,” “Take Me or Leave Me,” and “La Vie Bohème,” RENT is a powerful, deeply human story that continues to move generations.",
    preShowDescLink: "",
    runTime: "2 hours and 20 minutes with one 15-minute intermission.",
    accessibility:
      "Accessible wheelchair/scooter seating and Listening Devices are available for all Mainstage performances.",
    contentAwareness:
      "This show contains adult content, drug use, strong language, and period-specific references to the HIV/AIDS crisis.",
  },
  {
    playName: "Hello, Dolly!",
    playDate: "April seventeenth and nineteenth, 2026",
    description:
      "It only takes a moment to fall in love with this classic musical comedy! Hello, Dolly! is the story of the irrepressible matchmaker Dolly Gallagher Levi, who is determined to find love for herself and others in 19th-century New York. With lavish costumes, spirited dance numbers, and an unforgettable score, “Put On Your Sunday Clothes”, “Before the Parade Passes By”, this Tony Award–winning hit is pure theatrical joy.",
    preShowDescLink: "https://docs.google.com/document/d/1xIb1x30qh6iGD-jwW8uvIBgKMD8AMDJ8",
    runTime: "2 hours and 30 minutes with one 15-minute intermission.",
    accessibility:
      "Accessible wheelchair/scooter seating and Listening Devices are available for all Mainstage performances.",
    contentAwareness: "This show is suitable for all audiences.",
  },
  {
    playName: "In The Heights",
    playDate: "June nineteenth and twenty-first, 2026",
    description:
      "Before Hamilton, there was In the Heights. With a vibrant score blending hip-hop, salsa, merengue, and soul, this Tony Award–winning musical tells the story of a tight-knit community on the brink of change in New York’s Washington Heights. Featuring unforgettable characters and songs like “Breathe,” “96,000,” and “Carnaval del Barrio,” this show is a celebration of heritage, home, and hope.",
    preShowDescLink: "",
    runTime: "2 hours and 20 minutes with one 15-minute intermission.",
    accessibility:
      "Accessible wheelchair/scooter seating and Listening Devices are available for all Mainstage performances.",
    contentAwareness:
      "This show contains strong language and themes of immigration, loss, and cultural identity.",
  },
];
  
  
  export default acts;
